<template>
  <div id="datos">
      <h3 class="text-overflow title text-Condensed-Light mb-2">{{cliente.nombre}}</h3>
      <a class="primary-color" :href="'mailto:' + cliente.email">
        <v-icon small class="primary-color mr-2">mail_outline</v-icon>
        <span class="font-weight-medium subheading">{{cliente.email}}</span>
         <v-icon small class="primary-color float-right mt-1">east</v-icon>
      </a>
    <div class="primary-color">
      <v-icon small class="mr-2 primary-color">phone_iphone</v-icon>
      <span class="font-weight-medium">{{cliente.movil === '' ? cliente.telefonoUno ==='' ? cliente.telefonoDos : cliente.telefonoUno : cliente.movil }}</span>
    </div>
     <!-- <div class="mt-3 text-right">
     <a class="unishop-button-secondary unishop-keep-shopping">SMS</a>
    </div> -->
  </div>
</template>
<script>

export default {
  name: 'clienteDatos',
  props: {
    cliente: { type: Object, required: true }
  },
  data() {
    return {
      
    }
  },
  methods: {
    
  },
}
</script>
